<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('addEditParution.pageParution.popUpModification.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field
          :label="$t('addEditParution.pageParution.emplacement')"
          class="column is-3 mgb-0">
          <b-select
            v-model="page.emplacementId"
            expanded>
            <option
              v-for="item in emplacements"
              :key="item.id"
              :value="item.id">
              {{ item.libelle }}
            </option>
          </b-select>
        </b-field>
        <b-field
          :label="$t('addEditParution.pageParution.surface')"
          class="column is-3 mgb-0">
          <b-select
            v-model="page.surfaceId"
            expanded>
            <option
              v-for="item in surfaces"
              :key="item.id"
              :value="item.id">
              {{ item.libelle }}
            </option>
          </b-select>
        </b-field>
        <b-field
          :label="$t('addEditParution.pageParution.couleurEncart')"
          class="column is-3 mgb-0">
          <b-select
            v-model="page.couleurEncartId"
            expanded>
            <option
              v-for="item in couleurEncarts"
              :key="item.id"
              :value="item.id">
              {{ item.libelle }}
            </option>
          </b-select>
        </b-field>
        <b-field
          :label="$t('addEditParution.pageParution.largeurUtile')"
          class="column is-3 mgb-0">
          <b-input
            v-model.number="page.largeurUtile"
            :use-html5-validation="false"
            type="number"
            min="0">
          </b-input>
        </b-field>
        <b-field
          :label="$t('addEditParution.pageParution.hauteurUtile')"
          class="column is-3 mgb-0">
          <b-input
            v-model.number="page.hauteurUtile"
            :use-html5-validation="false"
            type="number"
            min="0">
          </b-input>
        </b-field>
        <b-field
          :label="$t('addEditParution.pageParution.largeur')"
          class="column is-3 mgb-0">
          <b-input
            v-model.number="page.largeur"
            :use-html5-validation="false"
            type="number"
            min="0">
          </b-input>
        </b-field>
        <b-field
          :label="$t('addEditParution.pageParution.hauteur')"
          class="column is-3 mgb-0">
          <b-input
            v-model.number="page.hauteur"
            :use-html5-validation="false"
            type="number"
            min="0">
          </b-input>
        </b-field>
        <b-field
          :label="$t('addEditParution.pageParution.margeGauche')"
          class="column is-3 mgb-0">
          <b-input
            v-model.number="page.margeGauche"
            :use-html5-validation="false"
            type="number"
            min="0">
          </b-input>
        </b-field>
        <b-field
          :label="$t('addEditParution.pageParution.margeHaute')"
          class="column is-3 mgb-0">
          <b-input
            v-model.number="page.margeHaute"
            :use-html5-validation="false"
            type="number"
            min="0">
          </b-input>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="modifier()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import genererPageParution from '@/services/presse/parution/genererPageParution';

export default {
  props: {
    items: {
      type: Array,
      require: true,
    },
    parution: {
      type: Object,
      required: true,
    },
    emplacements: {
      type: Array,
      require: true,
    },
    surfaces: {
      type: Array,
      require: true,
    },
    couleurEncarts: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      page: {},
    };
  },
  methods: {
    modifier() {
      this.items.forEach(item => {
        const index = this.parution.pages.findIndex(p => p.id === item.id);
        if (index !== -1) {
          const page = {
            ...this.parution.pages[index],
            ...this.page,
          };
          this.parution.pages.splice(index, 1, page);
        }
      });
      this.$parent.close();
    },
  },
  mounted() {
    if (this.items.length === 1) {
      this.page = cloneDeep(this.items[0]);
    } else {
      this.page = genererPageParution(0);
    }
    delete this.page.ordre;
    delete this.page.nom;
    delete this.page.id;
    delete this.page.isCreate;
    delete this.page.selected;
  },
};
</script>
